import { useQuery } from '@tanstack/react-query';

import defaultFeatureFlags from '@tests/jest/mocks/feature-config.json';
import { FeatureFlag } from '@app/contexts';
import { makeRequest } from '@app/utils';

type FeatureFlagsDto = {
  features: FeatureFlag[];
};

export const useFeatureFlagsFetch = (isEnabled: boolean): FeatureFlag[] => {
  const featureFlagsQuery = useQuery<FeatureFlagsDto, unknown, FeatureFlag[]>(
    ['featureFlags'],
    () =>
      makeRequest<FeatureFlagsDto>({
        url: '/opac-configurations/features',
      }).catch(() => defaultFeatureFlags as unknown as FeatureFlagsDto),
    {
      enabled: isEnabled,
      select: ({ features }) => features,
    }
  );

  return featureFlagsQuery.data as FeatureFlag[];
};
